/*========GET CREDITS LIST========*/
export const GET_HISTORY_RECOVERY_SUCCESS   = 'GET_HISTORY_RECOVERY_SUCCESS';
export const GET_HISTORY_RECOVERY_FAIL      = 'GET_HISTORY_RECOVERY_FAIL';